import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import type { PaymentFilters as PaymentFiltersType } from '../../types';

interface PaymentFiltersProps {
  filters: PaymentFiltersType;
  onFiltersChange: (filters: PaymentFiltersType) => void;
}

export const PaymentFilters: React.FC<PaymentFiltersProps> = ({
  filters,
  onFiltersChange
}) => {
  const handleSearchChange = (search: string) => {
    onFiltersChange({ ...filters, search });
  };

  const handleDateFromChange = (dateFrom: string) => {
    onFiltersChange({ ...filters, dateFrom });
  };

  const handleDateToChange = (dateTo: string) => {
    onFiltersChange({ ...filters, dateTo });
  };

  return (
    <div className="payment-controls">
      <div className="payment-controls-left">
        {/* Search */}
        <div className="payment-search">
          <MagnifyingGlassIcon className="payment-search-icon" />
          <input
            type="text"
            value={filters.search}
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder="Rechercher..."
            className="payment-search-input"
          />
          {filters.search && (
            <button
              type="button"
              onClick={() => handleSearchChange('')}
              className="payment-search-clear"
              aria-label="Clear search"
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          )}
        </div>

        {/* Date From */}
        <div className="payment-date-filter">
          <label>Date début</label>
          <input
            type="date"
            value={filters.dateFrom || ''}
            onChange={(e) => handleDateFromChange(e.target.value)}
            className="payment-select"
          />
        </div>

        {/* Date To */}
        <div className="payment-date-filter">
          <label>Date fin</label>
          <input
            type="date"
            value={filters.dateTo || ''}
            onChange={(e) => handleDateToChange(e.target.value)}
            className="payment-select"
          />
        </div>
      </div>
    </div>
  );
};
